import request from "@/util/require";
//字典管理
export function dict(query) {
  return request({
    url: "/fApi/dict/" + query,
    method: "get"
    // params: query
  });
}
//图片管理
export function imageList(query) {
  return request({
    url: "/fApi/imageManage/list",
    method: "get",
    params: query
  });
}
//根据图片id获取图片
export function imageManageById(query) {
  return request({
    url: "/fApi/imageManage",
    method: "get",
    params: query
  });
}
// 获取功能分类列表
export function functionTypeList(query) {
  return request({
    url: "/fApi/functionType/list",
    method: "get",
    params: query
  });
}
//获取功能分类列表
export function functionTypeFindAll(query) {
  return request({
    url: "/fApi/functionType/findAll",
    method: "get",
    params: query
  });
}
//获取功能分类详细信息
export function functionTypeDetail(query) {
  return request({
    url: "/fApi/functionType",
    method: "get",
    params: query
  });
}
//品牌分类

// 获取品牌分类列表
export function brandTypeList(query) {
  return request({
    url: "/fApi/brandType/list",
    method: "get",
    params: query
  });
}
//获取品牌分类列表
export function brandTypeFindAll(query) {
  return request({
    url: "/fApi/brandType/findAll",
    method: "get",
    params: query
  });
}
//获取品牌分类详细信息
export function brandTypeDetail(query) {
  return request({
    url: "/fApi/brandType",
    method: "get",
    params: query
  });
}

// 商品管理
export function productList(query) {
  return request({
    url: "/fApi/product/list",
    method: "get",
    params: query
  });
}

// 获取商品详细信息
export function productDetail(query) {
  return request({
    url: "/fApi/product/" + query,
    method: "get"
  });
}

// 在线留言
export function onlineAdd(data) {
  return request({
    url: "/fApi/online/add",
    method: "post",
    data: data
  });
}

//广告管理 advertisingId

// 获取广告管理详细信息
export function imageAdvertisingDetail(query) {
  return request({
    url: "/fApi/imageAdvertising/" + query,
    method: "get"
  });
}
// 获取广告管理列表
export function imageAdvertisingList(query) {
  return request({
    url: "/fApi/imageAdvertising/list",
    method: "get",
    params: query
  });
}

//栏目管理

// 获取查询栏目表列表
export function columnList(query) {
  return request({
    url: "/fApi/column/list",
    method: "get",
    params: query
  });
}
// 获取所有栏目表

export function columnFindAll(query) {
  return request({
    url: "/fApi/column/findAll",
    method: "get",
    params: query
  });
}
// 获取栏目详细信息 columnId
export function column(query) {
  return request({
    url: "/fApi/column",
    method: "get",
    params: query
  });
}
// 获取联系方式列表
// 联系方式分类(0:涂料销售，1：水性树脂销售，2：粘胶剂销售，3：技术服务)
export function contactList(query) {
  return request({
    url: "/fApi/contact/list",
    method: "get",
    params: query
  });
}
// 咨询列表infoManage/list
export function infoManageList(query) {
  return request({
    url: "/fApi/infoManage/list",
    method: "get",
    params: query
  });
}
//  获取资讯管理详细信息 infoId
export function infoManageDetail(query) {
  return request({
    url: "/fApi/infoManage/" + query,
    method: "get"
  });
}

//获取文件列表
export function fileList(query) {
  return request({
    url: "/fApi/file/list",
    method: "get",
    params: query
  });
}

//查询功能
export function search(query) {
  return request({
    url: "/fApi/product/search",
    method: "get",
    params: query
  });
}

//获取验证码
export function getchaImg(query) {
  return request({
    url: "/captchaImage",
    method: "get",
    params: query
  });
}

//人才招聘
export function recruitList(query) {
  return request({
    url: "/fApi/recruit/list",
    method: "get",
    params: query
  });
}
